import React from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { enums } from "../enums";

const elementVariants = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  body: "p",
  span: "span",
};

const Typography = ({
  variant,
  style,
  className,
  component,
  state = "default",
  children,
  ...props
}) => {
  const Component = component ? elementVariants[component] : "p";
  const baseClass = `pm-typography-${variant}`;
  const stateClass = `pm-typography--${state}`;

  const typographyClassName = clsx(baseClass, stateClass, className);
  return (
    <Component className={typographyClassName} style={style} {...props} >
      {children}
    </Component>
  );
};

Typography.propTypes = {
  variant: PropTypes.oneOf(enums.typographyVariants),
  state: PropTypes.oneOf(enums.typographyStates),
  style: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.string,
};

export default Typography;
